// import Cookies from 'js-cookie';
import actions from './actions';

const {
  LOGIN_BEGIN,
  LOGIN_SUCCESS,
  LOGIN_ERR,
  LOGOUT_BEGIN,
  LOGOUT_SUCCESS,
  LOGOUT_ERR,
  LOGGED_CHECK_BEGIN,
  LOGGED_CHECK_SUCCESS,
  LOGGED_CHECK_ERR,
  REGISTER_BEGIN,
  REGISTER_SUCCESS,
  REGISTER_ERR
} = actions;

const initState = {
  initialize: false,
  isLoggedIn: false,
  userData: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const AuthReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case REGISTER_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case REGISTER_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LOGIN_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        userData: data,
        loading: false,
      };
    case LOGIN_ERR:
      return {
        ...state,
        isLoggedIn: false,
        userData: null,
        error: err,
        loading: false,
      };
    case LOGOUT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        userData: null,
        loading: false,
      };
    case LOGOUT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LOGGED_CHECK_BEGIN:
      return {
        ...state,
        initialize: false,
      };
    case LOGGED_CHECK_SUCCESS:
      return {
        ...state,
        initialize: true,
        isLoggedIn: true,
        userData: data,
      };
    case LOGGED_CHECK_ERR:
      return {
        ...state,
        isLoggedIn: false,
        initialize: true,
        isLoggedIn: false,
      };
    default:
      return state;
  }
};
export default AuthReducer;
